/**
 * 
 * 
 * 
 * 
 */
import store from '../store'

/**
 * 失败后需要将全部区块翻开
 * 并设置状态
 *
 * @export
 * @param {*} matrix
 */
export function gameOver () {
    store.dispatch('setGameOver', true)
}
 
/**
 * 赢取比赛的判定
 *
 * @export
 * @returns  win / true  or fase
 */
export function judgeWin(totalCount) {
    // 炸弹Square
    // const flagBombs = store.state.bombCount
    // 旗子Square
    // const flagCount = store.state.flagCount
    // 所有可翻开的Square
    // const valueCount = store.state.totalCount - flagBombs.length
    // 已经被翻开的Square
    // 要WIN 必须要满足以下条件：
    // 1 所有雷被旗子标记 && 
    // const isAllBombFlaging = flagBombs.filter(b => !b.isFlag)
    // 2 标记旗子的数量和炸弹数量相同 &&
    // const isUseAllFlag = flagBombs.length === flagCount.length
    // 3 所有可翻开的区块必须全部翻开
    // const isAllFliped = valueCount === flipCount
    // 全部满足可设置为WIN
    // if (isAllBombFlaging && isUseAllFlag && isAllFliped) {
    if (totalCount === 0) {
        store.dispatch('setGameWin', true)
    }
}

/**
 * 通过数字返回字符串当前难度
 *
 * @export
 * @param {*} level
 * @returns
 */
export function getLevel (level) {
    switch (level) {
        case 1:
            return 'easy'
        case 2:
            return 'normal'
        case 3:
            return 'hard'
        case 4:
            return 'hell'
        default:
        return 'normal'
    }
}